import React, { useEffect, useState } from 'react';
import { Menu, Layout, Alert } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';

import Logo from './Logo';
import NavProfile from './NavProfile';
import NavSearch from './NavSearch';
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from 'constants/ThemeConstant';
import utils from 'utils';

const { Header } = Layout;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
  } = props;
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  useEffect(() => {
    if (localStorage.getItem('navCollapsed')) {
      toggleCollapsedNav(localStorage.getItem('navCollapsed') === 'true');
    }
  }, []);

  const onToggle = () => {
    if (!isMobile) {
      localStorage.setItem('navCollapsed', !navCollapsed);
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = utils.getColorContrast(headerNavColor);
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return '0px';
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  const mobileTopNavItems = [
    isNavTop && !isMobile
      ? null
      : {
          key: 'mobileTopNav_0',
          icon:
            navCollapsed || isMobile ? (
              <MenuUnfoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            ) : (
              <MenuFoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            ),
        },
  ];

  const { hostname } = window.location;
  // Matches `zapmanagement.io` & `www.zapmanagement.io`
  const isProduction = /^(www\.)?zapmanagement\.io$/.test(hostname);

  return (
    <Header
      className={`app-header ${mode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <Logo logoType={mode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <Menu mode="horizontal" items={mobileTopNavItems} />
          </div>

          {isProduction ? null : (
            <Alert
              message={
                <div>
                  You are now on <strong>{hostname}</strong>
                </div>
              }
              type="warning"
              // closable
              showIcon
            />
          )}

          <div className="nav-right">
            <NavProfile />
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav } = theme;
  return { navCollapsed, navType, headerNavColor, mobileNav };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
